<template>
  <v-slide-y-transition mode="out-in">
    <doughnut-chart
      :style="{
        height: height
      }"
      v-if="type === 'doughnut'"
      :chart-data="chartData"
      :options="options"
    ></doughnut-chart>
    <bar-chart
      :style="{
        height: height
      }"
      v-if="type === 'bar'"
      :chart-data="chartData"
      :options="options"
    ></bar-chart>
    <horizontal-bar-chart
      :style="{
        height: height
      }"
      v-if="type === 'horizontal-bar'"
      :chart-data="chartData"
      :options="options"
    ></horizontal-bar-chart>
    <pie-chart
      :style="{
        height: height
      }"
      v-if="type === 'pie'"
      :chart-data="chartData"
      :options="options"
    ></pie-chart>
    <line-chart
      :style="{
        height: height
      }"
      v-if="type === 'line'"
      :chart-data="chartData"
      :options="options"
    ></line-chart>
    <polar-area-chart
      :style="{
        height: height
      }"
      v-if="type === 'polar-area'"
      :chart-data="chartData"
      :options="options"
    ></polar-area-chart>
    <bubble-chart
      :style="{
        height: height
      }"
      v-if="type === 'bubble'"
      :chart-data="chartData"
      :options="options"
    ></bubble-chart>
    <radar-chart
      :style="{
        height: height
      }"
      v-if="type === 'radar'"
      :chart-data="chartData"
      :options="options"
    ></radar-chart>
  </v-slide-y-transition>
</template>

<script>
  'use strict'

  import DoughnutChart from './charts/doughnut'
  import BarChart from './charts/bar'
  import HorizontalBarChart from './charts/horizontal-bar'
  import PieChart from './charts/pie'
  import LineChart from './charts/line'
  import PolarAreaChart from './charts/polar-area'
  import BubbleChart from './charts/bubble'
  import RadarChart from './charts/radar'

  export default {

    name: 'VueChart',

    components:
    {
      DoughnutChart,
      BarChart,
      HorizontalBarChart,
      PieChart,
      LineChart,
      PolarAreaChart,
      BubbleChart,
      RadarChart
    },

    props: {
      type: {
        type: String,
        default: 'bar'
      },
      chartData: {
        type: Object,
        required: true
      },
      options: {
        type: Object,
        required: true
      },
      height: {
        type: String,
        default: 'auto',
        required: true
      },
      width: {
        type: String,
        default: 'auto',
        required: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/vue-chart/vue-chart.vue